// Product templates for common categories
export const productTemplates = {
  'yoga-mat': {
    name: 'Yoga Mat',
    category: 'yoga-equipment',
    description: 'High-quality yoga mat for practice',
    shippingWeight: 1.5,
    shippingDimensions: { length: 68, width: 24, height: 5 },
    shippingClass: 'standard',
    returnPolicy: '30 days return',
    warranty: '1 year manufacturer warranty',
    tags: ['yoga', 'mat', 'fitness']
  },
  'yoga-blocks': {
    name: 'Yoga Blocks',
    category: 'yoga-equipment',
    description: 'Foam yoga blocks for support and alignment',
    shippingWeight: 0.5,
    shippingDimensions: { length: 23, width: 15, height: 8 },
    shippingClass: 'standard',
    returnPolicy: '30 days return',
    warranty: '6 months warranty',
    tags: ['yoga', 'blocks', 'support']
  },
  'yoga-strap': {
    name: 'Yoga Strap',
    category: 'yoga-equipment',
    description: 'Durable cotton yoga strap for stretching',
    shippingWeight: 0.2,
    shippingDimensions: { length: 200, width: 4, height: 1 },
    shippingClass: 'standard',
    returnPolicy: '30 days return',
    warranty: '1 year warranty',
    tags: ['yoga', 'strap', 'stretching']
  },
  'meditation-cushion': {
    name: 'Meditation Cushion',
    category: 'meditation',
    description: 'Comfortable meditation cushion for seated practice',
    shippingWeight: 1.0,
    shippingDimensions: { length: 40, width: 40, height: 15 },
    shippingClass: 'standard',
    returnPolicy: '30 days return',
    warranty: '1 year warranty',
    tags: ['meditation', 'cushion', 'zen']
  },
  'essential-oils': {
    name: 'Essential Oils',
    category: 'wellness',
    description: 'Pure essential oils for aromatherapy',
    shippingWeight: 0.1,
    shippingDimensions: { length: 10, width: 5, height: 15 },
    shippingClass: 'standard',
    returnPolicy: '30 days return (unopened)',
    warranty: 'No warranty - consumable product',
    tags: ['essential-oils', 'aromatherapy', 'wellness']
  },
  'protein-powder': {
    name: 'Protein Powder',
    category: 'supplements',
    description: 'High-quality protein supplement',
    shippingWeight: 1.0,
    shippingDimensions: { length: 20, width: 15, height: 25 },
    shippingClass: 'standard',
    returnPolicy: '30 days return (unopened)',
    warranty: 'No warranty - consumable product',
    tags: ['protein', 'supplement', 'fitness']
  },
  'resistance-bands': {
    name: 'Resistance Bands Set',
    category: 'fitness-equipment',
    description: 'Set of resistance bands for strength training',
    shippingWeight: 0.8,
    shippingDimensions: { length: 30, width: 20, height: 5 },
    shippingClass: 'standard',
    returnPolicy: '30 days return',
    warranty: '1 year warranty',
    tags: ['resistance-bands', 'fitness', 'strength-training']
  },
  'water-bottle': {
    name: 'Water Bottle',
    category: 'accessories',
    description: 'Eco-friendly reusable water bottle',
    shippingWeight: 0.3,
    shippingDimensions: { length: 25, width: 8, height: 25 },
    shippingClass: 'standard',
    returnPolicy: '30 days return',
    warranty: '1 year warranty',
    tags: ['water-bottle', 'eco-friendly', 'hydration']
  },
  'yoga-towel': {
    name: 'Yoga Towel',
    category: 'accessories',
    description: 'Absorbent yoga towel for hot yoga',
    shippingWeight: 0.4,
    shippingDimensions: { length: 70, width: 25, height: 2 },
    shippingClass: 'standard',
    returnPolicy: '30 days return',
    warranty: '6 months warranty',
    tags: ['yoga-towel', 'hot-yoga', 'accessories']
  },
  'incense-sticks': {
    name: 'Incense Sticks',
    category: 'meditation',
    description: 'Natural incense sticks for meditation',
    shippingWeight: 0.1,
    shippingDimensions: { length: 25, width: 2, height: 2 },
    shippingClass: 'standard',
    returnPolicy: '30 days return (unopened)',
    warranty: 'No warranty - consumable product',
    tags: ['incense', 'meditation', 'aromatherapy']
  }
};

export const getTemplateCategories = () => {
  return Object.keys(productTemplates);
};

export const getTemplate = (templateId) => {
  return productTemplates[templateId];
};

export const getTemplatesByCategory = (category) => {
  return Object.entries(productTemplates)
    .filter(([_, template]) => template.category === category)
    .map(([id, template]) => ({ id, ...template }));
};



